import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from "../views/Login.vue";
import Home from '../views/Home.vue';
import Center from '../views/center.vue'

Vue.use(VueRouter)

const initRouters = []
let pages = require.context('./modules', false, /\.module\.js/)
pages.keys().forEach((key) => {
    if (pages(key).default) initRouters.push(pages(key).default)
})
// 原始路由
const routes = [{
        path: "/",
        name: "Login",
        hidden: true,
        component: Login,
        alias: "/login"
    },
    {
        path: '/home',
        redirect: '/home1',
        component: () => import('@/layout/index.vue'),
        hidden: false,
        children: [{
            path: '/home1',
            name: 'Home',
            component: Home,
            hidden: false,
            meta: {
                title: '首页',
                icon: 'iconfont icon-home'
            },
        }, ],
    },
    {
        path: '/center',
        redirect: '/center1',
        component: () => import('@/layout/index.vue'),
        hidden: false,
        children: [{
            path: '/center1',
            name: 'Center',
            component: Center,
            hidden: false,
            meta: {
                title: '个人中心',
                icon: 'el-icon-user'
            },
        }, ],
    },
    ...initRouters,
]

const createRouter = () =>
    new VueRouter({
        scrollBehavior: () => ({
            y: 0
        }),
        routes: routes,
    })

const router = createRouter()


router.beforeEach((to, from, next) => {
    if (to.path != "/") {
        if (localStorage.getItem("token")) {
            next();
        } else {
            next({
                path: "/"
            });
            localStorage.removeItem()
        }
    } else {
        next();
    }
})


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}
export default router

// route 文件格式
// modules 文件夹中 *.module.js 文件自动引入  文件名以 小写 - 分隔  例：invoice-manage.module.js
// .vue 文件 需写name属性，大驼峰格式 例：TestTest
// {
//     path: "/test-test",                              小写 - 分隔 test-test
//     name: "TestTest",                                大驼峰 TestTest
//     component: () => import(url),                    动态引入路径
//     redirect: "/test-page1",                         重定向 填默认自页面
//     meta: {
//        title: "质量管理",                             菜单名
//        icon: "iconfont sqzhiliangguanli"             菜单图标 引用iconfont图标库/element
//     },
//     children: [                                      子页面
//         {
//              path: "/testpage1",                     小写
//              name: "TestPage1",                      大驼峰 TestPage1
//              meta: { title: "质量查询" },             页面名
//              component: () => import(url),
//          }
//     ],
// }